import React from "react";

var supportSvg = function supportSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.756-13.908l-1.283 1.561C9.743 3.238 8.9 3 8 3s-1.744.238-2.473.653L4.244 2.092a7.037 7.037 0 0 0-2.152 2.152l1.561 1.283C3.238 6.257 3 7.1 3 8s.238 1.744.653 2.473l-1.561 1.283a7.037 7.037 0 0 0 2.152 2.152l1.283-1.561C6.257 12.762 7.1 13 8 13s1.744-.238 2.473-.653l1.283 1.561a7.037 7.037 0 0 0 2.152-2.152l-1.561-1.283C12.762 9.743 13 8.9 13 8s-.238-1.744-.653-2.473l1.561-1.283a7.037 7.037 0 0 0-2.152-2.152zM8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10zm0-1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  }));
};

supportSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var support = {
  category: 'icon',
  colorable: true,
  name: 'support',
  svg: supportSvg
};